import React, { useState, useEffect } from 'react';
import ItemWrap from '../components/item-wrap';
import useProps from '../../_util/useProps';

export default function(props) {
    const [value, setVal] = useState('2D');
    const { map } = useProps();

    useEffect(() => {}, []);

    const onChange = () => {
        const _value = value === '2D' ? '3D' : '2D';

        map.setViewMode(_value);

        setVal(_value);

        props.onChange && props.onChange(_value);
    };

    return (
        <ItemWrap>
            <div onClick={onChange}>{value}</div>
        </ItemWrap>
    );
}
